import DirectusCombobox from "../combobox";
import FilterWrapper from "components/filter/wrapper";
import React from "react";
import client from "directus/src/client";

export default function ToolCombobox({
    filter,
    hideLabel,
    className = "w-full",
    ...props
}) {
    if (hideLabel) {
        return (
            <div className={className}>
                <DirectusCombobox
                    client={client}
                    collection="tools"
                    fields={["id", "name"]}
                    searchKeys={["name"]}
                    filter={filter}
                    placeholder="Select tool"
                    {...props}
                />
            </div>
        );
    }

    return (
        <FilterWrapper label="Tool" className={className}>
            <DirectusCombobox
                client={client}
                collection="tools"
                fields={["id", "name"]}
                searchKeys={["name"]}
                filter={filter}
                {...props}
            />
        </FilterWrapper>
    );
}
